"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8540],{

/***/ 82305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ picture_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./constants/lazy-load-images.js
var PICTURE_LAZY_CLASS = "picture-lazy";
var PICTURE_LAZY_ATTRIBUTE = "data-source";

;// CONCATENATED MODULE: ./client/services/images-lazy-loading/images-lazy-loading.js

var lazyLoad = function(targetImage) {
    var io = new IntersectionObserver(function(imageEntries, observer) {
        imageEntries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var img = entry.target;
                removeLazyLoadProperty(img);
                observer.disconnect();
            }
        });
    });
    io.observe(targetImage);
};
var removeLazyLoadProperty = function(img) {
    var src = img.getAttribute(PICTURE_LAZY_ATTRIBUTE);
    if (src) {
        img.setAttribute("src", src);
        img.classList.remove(PICTURE_LAZY_CLASS);
        img.removeAttribute(PICTURE_LAZY_ATTRIBUTE);
    }
};

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./server/services/files-service/files-service.js
var files_service = __webpack_require__(14688);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/picture/picture-component.scss.js

var StyledPictureComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("picture", {
    target: "e1ujfqv60"
})("&.blur-image img{filter:blur(10px);}.picture-lazy{opacity:0;}");

;// CONCATENATED MODULE: ./components/core/picture/picture-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}














var PictureComponent = function(props) {
    var ref = (0,react.useState)(false), useLazyLoad = ref[0], setUseLazyLoad = ref[1];
    var _image = (0,react.useRef)(null);
    var shouldUseLazyLoad = props.shouldUseLazyLoad, mobile = props.mobile, imagesLazyLoad = props.imagesLazyLoad, src = props.src, alt = props.alt, shouldTrackMouseEvents = props.shouldTrackMouseEvents, className = props.className, pictureClass = props.pictureClass, specificImageStyle = props.specificImageStyle, assetQuality = props.assetQuality, isDecorative = props.isDecorative, extraCloudinaryTransformations = props.extraCloudinaryTransformations, isPreview = props.isPreview, skipCloudinaryConversion = props.skipCloudinaryConversion, pictureComponentHeight = props.pictureComponentHeight, onImageLoad = props.onImageLoad;
    (0,react.useEffect)(function() {
        lazyLoadImageIfNeeded();
        // This is to make sure picturefill is loaded only on the client as it breaks when loaded on the server
        var picturefill = __webpack_require__(47229);
        picturefill();
    }, []);
    (0,react.useEffect)(function() {
        lazyLoadImageIfNeeded();
    }, [
        src
    ]);
    var lazyLoadImageIfNeeded = function() {
        var current = _image.current;
        if (validateLazyLoadImages()) lazyLoad(current);
        else removeLazyLoadProperty(current);
    };
    var isImageCompleted = function(img) {
        return (0,dom_utils_service.isImageLoaded)(_image.current);
    };
    var renderSource = function(src, media) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            srcSet: src,
            media: media
        });
    };
    var addLowResTransformations = function(cloudinaryTransformations) {
        return _object_spread_props(_object_spread({}, cloudinaryTransformations), {
            quality: cloudinary_service.LOW_RES_IMAGE_QUALITY_LEVEL,
            blur: cloudinary_service.IMAGE_DEFAULT_BLUR
        });
    };
    var addFakeRandomDefaultImageKeyForBrowserCacheBusting = function(cloudinaryTransformations) {
        var randInt = Math.ceil(Math.random() * 1000);
        return _object_spread_props(_object_spread({}, cloudinaryTransformations), {
            defaultImage: randInt
        });
    };
    var getCloudinaryTransformations = function() {
        var cloudinaryTransformations = (0,cloudinary_service.extractCloudinaryTransformations)(_object_spread({}, specificImageStyle, extraCloudinaryTransformations));
        if (isLowResImage()) {
            cloudinaryTransformations = addLowResTransformations(cloudinaryTransformations);
        }
        if (isPreview) {
            // for image preview we add a non existing default image key just to clear browser cache for uploading image with same name problem
            cloudinaryTransformations = addFakeRandomDefaultImageKeyForBrowserCacheBusting(cloudinaryTransformations);
        }
        return cloudinaryTransformations;
    };
    var getMobileImageSource = function(cloudinaryTransformations) {
        if (!mobile) return null;
        if ((0,cloudinary_service.isCloudinaryUrl)(mobile) || skipCloudinaryConversion) return mobile;
        return (0,cloudinary_service.generateCloudinaryImageUrl)(mobile, cloudinaryTransformations);
    };
    var getImageNameFromSrc = function(imgSrc) {
        if (!imgSrc) return "";
        try {
            var lastSeparator = imgSrc.lastIndexOf("/");
            var fileName = imgSrc.substr(lastSeparator + 1);
            var fileNameWithoutExtension = (0,files_service.removeFileExtension)(fileName);
            // our S3 image uploads code adds UUID to files - if this is the case we remove it
            if (fileName.length > utils_service.UUID_LENGTH && (0,utils_service.isUUID)(fileName.substring(0, utils_service.UUID_LENGTH))) {
                fileNameWithoutExtension = fileNameWithoutExtension.substring(utils_service.UUID_LENGTH);
            }
            return fileNameWithoutExtension.replace(/-|_/g, " ").trim(); // replace all - and _ with a space
        } catch (error) {
            console.error("Error generating alt text for imgSrc: ".concat(imgSrc, ":"), error);
            return imgSrc;
        }
    };
    var onVisibilityChange = function(visible, data) {
        if (visible && useLazyLoad) {
            setUseLazyLoad(false);
        }
    };
    // Rendering low res image if needed when using lazy load
    var isLowResImage = function() {
        return useLazyLoad;
    };
    var validateLazyLoadImages = function() {
        if (!window) return false;
        if (!("IntersectionObserver" in window)) return false;
        return shouldUseLazyLoad;
    };
    var onMouseEnter = function() {
        if (!shouldTrackMouseEvents) return;
        BigBrain("track", bigbrain_event_types.MOUSE_ENTER_IMAGE_ELEMENT, {
            placement: src,
            kind: alt
        });
    };
    var onClick = function() {
        if (!shouldTrackMouseEvents) return;
        BigBrain("track", bigbrain_event_types.CLICK_IMAGE_ELEMENT, {
            placement: src,
            kind: alt
        });
    };
    var renderPicture = function() {
        var cloudinaryTransformations = getCloudinaryTransformations();
        var cloudinaryUrl = (0,cloudinary_service.isCloudinaryUrl)(src) || skipCloudinaryConversion ? src : (0,cloudinary_service.generateCloudinaryImageUrl)(src, cloudinaryTransformations, {
            assetQuality: assetQuality
        });
        var mobileSrc = getMobileImageSource(cloudinaryTransformations);
        var imageAlt = isDecorative ? "" : alt || getImageNameFromSrc(src);
        var srcAttr = shouldUseLazyLoad ? PICTURE_LAZY_ATTRIBUTE : "src";
        var _obj;
        var imgAttrs = (_obj = {
            alt: imageAlt,
            ref: _image,
            className: classnames_default()(className, (0,_define_property/* default */.Z)({}, PICTURE_LAZY_CLASS, shouldUseLazyLoad))
        }, (0,_define_property/* default */.Z)(_obj, srcAttr, cloudinaryUrl), (0,_define_property/* default */.Z)(_obj, "style", specificImageStyle), (0,_define_property/* default */.Z)(_obj, "onLoad", onImageLoad || null), _obj);
        var topicImageInlineStyle = pictureComponentHeight ? {
            display: "flex",
            height: pictureComponentHeight,
            width: "100%"
        } : {};
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPictureComponent, {
            className: classnames_default()("picture-component", pictureClass, {
                "blur-image": isLowResImage() && !isImageCompleted()
            }),
            style: topicImageInlineStyle,
            children: [
                mobileSrc && renderSource(mobileSrc, vp_sizes/* MOBILE_QUERY */.lF),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", _object_spread_props(_object_spread({}, imgAttrs), {
                    onMouseEnter: onMouseEnter,
                    onClick: onClick
                }))
            ]
        });
    };
    if (imagesLazyLoad) {
        // when using lazy load - images will remain low res until visible in viewport
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
            offset: {
                top: 200
            },
            partialVisibility: true,
            onChange: onVisibilityChange,
            active: true,
            scrollCheck: true,
            children: renderPicture()
        });
    }
    return renderPicture();
};
/* harmony default export */ var picture_component = ((0,generic_config_context/* withGenericConfig */.P)(PictureComponent));
PictureComponent.defaultProps = {
    className: "",
    src: "",
    mobile: null,
    alt: "",
    pictureClass: "",
    specificImageStyle: {},
    screenRatios: {},
    imagesLazyLoad: false,
    shouldUseLazyLoad: false,
    shouldTrackMouseEvents: false,
    isDecorative: false,
    skipCloudinaryConversion: false
};


/***/ }),

/***/ 98181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ regular_asset_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/cloudinary-asset-qualities.js
var cloudinary_asset_qualities = __webpack_require__(65832);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/regular-asset-component.scss.js


var StyledRegularAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kmitw10"
})("width:100%;.asset-component-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;&.left{justify-content:flex-start;}&.center{justify-content:center;}&.right{justify-content:flex-end;}&.full-width{max-width:none;}.regular-asset-image-wrapper{.regular-asset-image{width:100% !important;height:auto;}}video{display:block !important;}}");

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/regular-asset-component.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var RegularAssetComponent = function(props) {
    var isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, backgroundColor = props.backgroundColor, width = props.width, mobileWidth = props.mobileWidth, position = props.position, asset = props.asset, assetQuality = props.assetQuality, useDynamicAsset = props.useDynamicAsset, hideControls = props.hideControls, dynamicAssetParamPath = props.dynamicAssetParamPath, fullWidth = props.fullWidth, useWindowMask = props.useWindowMask, minHeight = props.minHeight, segmentNumber = props.segmentNumber;
    var finalWidth = isMobileOrTabletBrowser && mobileWidth ? mobileWidth : width;
    var widthInPercentage = finalWidth ? "".concat(finalWidth, "%") : "auto";
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 1.0,
        triggerOnce: true
    }), 2), assetRef = ref[0], assetFullyInView = ref[1];
    (0,react.useEffect)(function() {
        if (asset && assetFullyInView) {
            var image = asset.image, video = asset.video;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.ASSET_COMPONENT_IS_FULLY_VISIBLE, {
                kind: (image === null || image === void 0 ? void 0 : image.src) || (video === null || video === void 0 ? void 0 : video.src),
                info1: segmentNumber
            });
        }
    }, [
        assetFullyInView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRegularAssetComponent, {
        className: "regular-asset-component",
        style: {
            backgroundColor: colors/* default */.Z[backgroundColor],
            minHeight: minHeight
        },
        ref: assetRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("asset-component-wrapper", position, {
                "full-width": fullWidth
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread_props(_object_spread({}, asset), {
                assetQuality: assetQuality,
                useDynamicAsset: useDynamicAsset,
                hideControls: hideControls,
                width: widthInPercentage,
                convertGifToVideo: true,
                className: "regular-asset-image-wrapper",
                imageClassName: "regular-asset-image",
                dynamicAssetParamPath: dynamicAssetParamPath,
                useWindowMask: useWindowMask
            }))
        })
    });
};
RegularAssetComponent.defaultProps = {
    width: 100,
    position: "center",
    asset: {
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/asset/timeline-view.png"
        }
    },
    assetQuality: cloudinary_asset_qualities.AUTO,
    fullWidth: false
};
/* harmony default export */ var regular_asset_component = ((0,segment_context/* withSegmentsData */.c)((0,generic_config_context/* withGenericConfig */.P)(RegularAssetComponent)));


/***/ }),

/***/ 97650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve;
    unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!ref && entryTarget && !triggerOnce && !skip) {
      // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView,
        entry: undefined
      });
    }
  }, [ref, entryTarget, triggerOnce, skip, initialInView]);
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map


/***/ })

}]);